import {cookiePost} from './fetch'

/**
 * A generic survey endpoint for submitting user survey answers. Only used for the
 * onboarding attribution survey currently.
 *
 * @param {Object} payload Contains information relating to the survey
 * @param {String} payload.answer The answer to the survey question
 * @param {String} payload.question The question that the survey is asking
 * @param {String} payload.survey_name The name of the survey in the database
 * @return {Promise} A Promise that is resolved when the fetch request finishes
 */
export const submitSurvey = (payload = {}) => cookiePost('/survey', payload)
